import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

import DoorRender from "./SaleDoorRender";

const layoutShellClass = (fullscreen) =>
    `Sale-section Sale-product-spec-layout${fullscreen ? " Sale-product-spec-layout--fullscreen" : ""}`;

const SaleProductSpecificationsSection = ({ selectedSale, setSelectedSale, children }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    useEffect(() => {
        document.body.style.overflow = isExpanded ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [isExpanded]);

    useEffect(() => {
        if (!isExpanded) return;
        const handleKeyDown = (e) => {
            if (e.key === "Escape") setIsExpanded(false);
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [isExpanded]);

    const shell = (
        <>
            <button
                type="button"
                className="Sale-product-spec-expand-btn"
                onClick={() => setIsExpanded(!isExpanded)}
                title={isExpanded ? "Exit fullscreen" : "Fullscreen"}
            >
                <i className={`fas ${isExpanded ? "fa-compress" : "fa-expand"}`}></i>
            </button>

            <div className="Sale-product-spec-form-wrap">{children}</div>

            {selectedSale.product === "Door" && (
                <aside className="Sale-product-spec-preview-wrap">
                    <p className="Sale-product-spec-preview-title">Live Preview</p>
                    <div className="Sale-bottom-door-render Sale-bottom-door-render--sticky">
                        <DoorRender selectedSale={selectedSale} setNewSale={setSelectedSale} />
                    </div>
                </aside>
            )}
        </>
    );

    if (isExpanded) {
        return createPortal(
            <div className={layoutShellClass(true)}>{shell}</div>,
            document.body,
        );
    }

    return <div className={layoutShellClass(false)}>{shell}</div>;
};

export default SaleProductSpecificationsSection;
